
import { Component, Vue, Prop } from "vue-property-decorator";
import Bus from "@/lib/Bus";
const bus: Bus = new Bus().getBus();
import ButtonVue from "@/lib/Button.vue";
import FinderInlineVue from "@/finder/FinderInline.vue";
import { ITask } from "../../server/src/task/ITask";
import ModalVue from "@/Modal.vue";
import { DateString } from "@/DateString";
import TaskSendVue from "./TaskSend.vue";
import TasksVue from  "@/task/Tasks.vue";


@Component({ name: 'TaskShowVue', components: { FinderInlineVue, ButtonVue, ModalVue, TaskSendVue, TasksVue } })
export default class TaskShowVue extends Vue {
  key = 0;
  key1: number = 0;
  @Prop(Object) task!: ITask;
  @Prop(Array) tasks!: ITask[];


  async mounted() {
    if (this.task) this.key++;
  }

  convert_date(d: string) {
    if (!d) return "";
    const s = DateString.toISOString(d);
    return s;
  }

  show_reply_to(t: ITask, show: boolean) {
    if (!t) return;
    if (!t!._id) return;
    const at = <any>t;
    at.show = show;
    this.key1++;
  }
  
  stop_propagation(e:any) {
    e.stopPropagation()
  }

  refresh() {
    this.$emit('refresh')
  }


  async redirect_show_email() {

    if (!this.task!.msg_url) return;


    let url=this.task.msg_url
    //url=url.replace("&viewmodel=ReadMessageItem","&viewmodel=ReadMessageItem?view=conv")

    console.log("-------------------",url)

    //window.location.href=url
    window.open(url, '_blank', 'noreferrer');
  }


  async redirect_conversation() {
      let addr = "https://outlook.office.com/mail/deeplink/readconv/<convID>"

      const encodedConversationId = "AAQkADBhYzhmNDQ1LWVhMmItNGM4Yy1iYmU1LTBmZjg4MzcxYzUxZAAQAPhkZ4WBkSNDuA8xNW1HujA=";
      const decodedConversationId = encodeURIComponent(atob(encodedConversationId));
      addr=addr.replace("<convID>", encodeURIComponent(encodedConversationId))
      let url:string = addr
      window.open(url, '_blank', 'noreferrer');
  }

    async redirect_create_email() {

  
     if (!this.task!.msg_url) return;

      let addr = "https://outlook.office365.com/owa/?path=/mail/action/reply&message=<message-weblink>&to=test1%40grafpol.com&replyall=true"
      addr=addr.replace("<message-weblink>",this.task!.msg_url)

      const p = this.task.parent
      
      let body="Wpisz tu tekst maila...%0D%0A"

      body = body.replace(/"/g, '%22');
      body = body.replace(/</g, '%3C');
      body = body.replace(/=/g, '%3D');
      body = body.replace(/</g, '%3E');


      if (p)  body+=p.prj_url+" "
      if (p)  body+=p.order_url+" "
      if (p)  body+=p.lbl_url+" "


      let url:string =""
      url+="&subject="+this.task.txt
      url+="&body="+body
      url = url.replace(/ /g, '%20');
      
      

      url=addr+url
      console.log(url)

      //window.location.href=url
      window.open(url, '_blank', 'noreferrer');
  }



}
